import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../../api/ApiService"; // adjust path if needed

const AuthContext = createContext();

let globalResetAuth = null; // for axios interceptor

export const AuthProvider = ({ children }) => {
  const [userType, setUserType] = useState(null);
  const [tokenGenerated, setTokenGenerated] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const [loading, setLoading] = useState(true); // ⭐ prevent flicker

  // ⭐ restore login on refresh (API call)
  useEffect(() => {
    const restoreLogin = async () => {
      try {
        const res = await api.get("/auth/check"); // ⭐ backend auth check API

        if (res?.userType) {
          setUserType(res.userType);     // admin/user
          setTokenGenerated(true); 
          setRoleId(res.role_id);       // cookie exists
        } else {
          setUserType(null);
          setTokenGenerated(false);
          setRoleId(null); 
        }
      } catch (e) {
        setUserType(null);
        setTokenGenerated(false);
        setRoleId(null);
      } finally {
        setLoading(false);
      }
    };

    restoreLogin();
  }, []);

  // ⭐ global reset (used in interceptor/logout)
  useEffect(() => {
    globalResetAuth = () => {
      setUserType(null);
      setTokenGenerated(false);
      setRoleId(null); 
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        userType,
        setUserType,
        tokenGenerated,
        setTokenGenerated,
        roleId,
        setRoleId,
        loading, // ⭐ important
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// ⭐ used in axios interceptor
export const resetAuth = () => {
  if (globalResetAuth) globalResetAuth();
};